<template>
  <div>
    <div>
      <input 
      type="file" 
      class="hide"
      accept=".gpx" 
      :id="id"
      @change="handleFileUpload" 
      />
      <slot name="upload-label"></slot>
    </div>
    <label :for="id" slot="upload-label">
      <v-layout :class="['TraceInput__emptyField']">
        <div>
          <v-icon large color="primary" :class="'mdi-vector-polyline'"></v-icon>
        </div>
      </v-layout> 
    </label>
    <v-flex layout align-center v-if="errorMessage">
      <p class="ruleText">
        <span>{{ errorMessage }} </span>
      </p>
    </v-flex>
  </div>
</template>

<script>
//import toGeoJSON  from '@mapbox/togeojson';
import gpxParser from 'gpxparser';

export default {
  data() {
    return {
      geojson: null,
      errorMessage:null,
      id: 'fileInput_' +
      Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '')
        .substr(0, 5),
    };
  },
  methods: {
    /**
     * Search the value of a direct child XML DOM element
     * 
     * @param  {Element} parent - Parent DOM Element
     * @param  {string} needle - Name of the searched element
     * 
     * @return {} The element value
     */
    searchChildElement(parent, needle) {

        let elements  = parent.querySelectorAll(needle);
        let finalElem = elements[0];

        if(elements.length > 1) {
            let directChilds = parent.childNodes;
            console.log('dir childs', directChilds)
            for(idx in directChilds) {
                elem = directChilds[idx];
                if(elem.tagName === needle) {
                    finalElem = elem;
                }
            }
        }

        return finalElem;
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (!/\.gpx$/.test(file.name)) {
        this.errorMessage = this.$t('traceInput.errors.fileExtension')
        return
      }
      console.log('file', file.type, file)
      //if (file && file.type !== 'application/gpx+xml') {
      //  this.$toast.show("Veuillez sélectionner un fichier .gpx valide.");
      //}
      const reader = new FileReader();
      reader.onload = (e) => {
        //const parser = new DOMParser();
        //const xmlDoc = parser.parseFromString(e.target.result, 'application/xml');
        // var dom = (new DOMParser()).parseFromString(xmlStr, 'text/xml');
        //this.geojson = e.target.result//toGeoJSON.gpx(xmlDoc);
        const gpx = new gpxParser();
        gpx.parse(e.target.result)

        //get style
        let colorElem = this.searchChildElement(gpx.xmlSource, 'color')
        let weightElem = this.searchChildElement(gpx.xmlSource, 'weight')
        let style = {}
        if (colorElem) {
          style.color = '#' + colorElem.childNodes[0].nodeValue
        }
        if (weightElem) {
          style.weight = weightElem.childNodes[0].nodeValue
        }
         
        console.log('gpx style',  style)
        
        if (!gpx.tracks || gpx.tracks.length === 0) {
          this.errorMessage = this.$t('traceInput.errors.noTrack')
          return
        }
        else if (gpx.tracks.length > 1) {
          this.errorMessage = this.$t('traceInput.errors.manyTracks')
          return
        } else {
          this.geojson = gpx.toGeoJSON();
          if (!this.geojson) {
            this.errorMessage = this.$t('traceInput.errors.parseError')
          return
          }
          this.geojson.features[0].properties = style
          this.$emit('get-trace', this.geojson)
        }
      
      };
      reader.readAsText(file);
      
    },
  },
};
</script>

<style scoped lang="sass">

.TraceInput__emptyField
  background: white
  cursor: pointer
  display: flex
  align-items: center
  border-radius: 4px

  div
    height: 40px
    width: 200px
    border: 2px dashed #009999
    border-radius: 2px
    display: flex
    justify-content: center
    align-items: center

.ruleText
  color: red;
  font-size: small;
  text-align: center;
  line-height: 120%;
  margin-top: 10px;

.hide
  display: none

.mdi-vector-polyline 
  display: inline-block;
  width: 1em;
  height: 1em;
  --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000' d='M2 3v6h2.95l2 6H6v6h6v-4.59L17.41 11H22V5h-6v4.57L10.59 15H9.06l-2-6H8V3M4 5h2v2H4m14 0h2v2h-2M8 17h2v2H8Z'/%3E%3C/svg%3E");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;

</style>
